import { auth } from "@utils/firebase";
import { useGetUser } from "@utils/hooks";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, Outlet } from "react-router-dom";

const RouteVerifyEmail = () => {
  const [user, userLoading] = useAuthState(auth);
  const { data: userData, isLoading: isLoadingUserData } = useGetUser();

  if (userLoading || isLoadingUserData) {
    return <></>;
  } else {
    if (user) {
      if (!user.emailVerified || !userData?.request_followup) {
        return <Outlet />;
      } else {
        return <Navigate to="/" />;
      }
    } else {
      return <Navigate to="/login" />;
    }
  }
};

export default RouteVerifyEmail;
